export const clickHandler = (
  e: any,
  setSelectedElement: any,
  index: string
) => {
  setSelectedElement(index);

  e.stopPropagation();

  const target: Element = e.currentTarget;

  const other = document.querySelectorAll("[data-x-selected]");

  if (other.length > 0) {
    other.forEach((e) => e.removeAttribute("data-x-selected"));
  }

  target.setAttribute("data-x-selected", "true");
};
